import BaseMemorizer from "../BaseMemorizer";

export default class BookingMemorizer extends BaseMemorizer{
    constructor() {
        super("updateBuchungCmd.php");
    }
}